exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-overlay-wrap[data-v-2c96ad0f] {\n  display: block;\n}\n.b-overlay[data-v-2c96ad0f] {\n  pointer-events: none; /* Same as BootstrapVue overlay */\n}\n", ""]);

// exports
